const eventQuery = {
  publishTileEvent: `query publishTileEvent ($topic: String!, $message: SNSMessageInput!, $attributes: SNSAttributeInput!) {
    publishTileEvent(topic: $topic, message: $message, attributes: $attributes)
  }`,
};

export default eventQuery;
